import React, { useState } from 'react';
import { Client } from 'boardgame.io/react';
import { SocketIO } from 'boardgame.io/multiplayer';
import WaterlooGame from '../game/index.js';
import Board from '../board/Board.jsx';
import Lobby from './Lobby.jsx';

// Determine server URL - same origin in production, localhost:8000 in dev
const SERVER_URL = window.location.port === '3000'
  ? 'http://localhost:8000'
  : window.location.origin;

export default function OnlineApp() {
  const [gameState, setGameState] = useState(null);

  if (!gameState) {
    return (
      <Lobby
        serverUrl={SERVER_URL}
        onJoinedMatch={setGameState}
      />
    );
  }

  const WaterlooClient = Client({
    game: WaterlooGame,
    board: Board,
    numPlayers: gameState.numPlayers,
    multiplayer: SocketIO({ server: SERVER_URL }),
    debug: false,
  });

  return (
    <div className="app-container">
      <WaterlooClient
        matchID={gameState.matchID}
        playerID={gameState.playerID}
        credentials={gameState.credentials}
        serverUrl={SERVER_URL}
        onJoinNewMatch={setGameState}
        playerNames={gameState.playerNames}
      />
    </div>
  );
}
